import { SET_USER, LOGOUT } from '../actions/authActions';

const initialState = {
    accessToken: null,
    email: null,
    gpid: null,
    firstName: null,
    lastName: null,
    displayName: null,
  };

const authReducer = (state = initialState, action : any) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        email: action.payload.email,
        gpid: action.payload.gpid,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        displayName: action.payload.displayName
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default authReducer;
